import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { Icon } from 'antd'
import { get } from 'lodash'
import { FilterMatchMode } from 'primereact/api'
import { Button } from 'primereact/button'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'
import { Toolbar } from 'primereact/toolbar'

import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import DataTable from '../../components/DataTable/DataTable'
import { RULES, validRule } from '../../constants/Entitlements'
import { exportCSV, exportExcel } from '../../util/exportUtils'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'
import { STATUS } from '../../util/walletStatus'
import { retrieveConfiguration } from './utils'

import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.css'
import 'primereact/resources/themes/lara-light-indigo/theme.css'

const ListCustomerWallets = function ({ match, history }) {
  const [formattedData, setFormattedData] = useState({})
  const auth = useSelector((state) => state.auth)
  const [globalFilterValue, setGlobalFilterValue] = useState('')
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    regional: { value: null, matchMode: FilterMatchMode.CONTAINS },
    district: { value: null, matchMode: FilterMatchMode.CONTAINS },
    professional: { value: null, matchMode: FilterMatchMode.CONTAINS },
    totalOfCustomers: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status_name: { value: null, matchMode: FilterMatchMode.CONTAINS }
  })
  const gridRef = useRef()

  useEffect(() => {
    const hasAccess = validRule(RULES.CUSTOMER_LINKS) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }

    getRegionLinks({ active: true })
  }, [])

  const onGlobalFilterChange = (e) => {
    const value = e.target.value
    let _filters = { ...filters }

    _filters['global'].value = value

    setFilters(_filters)
    setGlobalFilterValue(value)
  }

  const exportCSVData = () => {
    exportCSV(formattedData.items, 'lista_de_carteiras')
  }

  const exportExcelData = () => {
    exportExcel(formattedData.items, 'lista_de_carteiras')
  }

  async function getRegionLinks(params) {
    try {
      const formattedConfiguration = await retrieveConfiguration(auth.auth.organizationId)
      const items = await request(api.listEibCarteiraEleitos(params))
      const formattedRows = items.map((item, index) => {
        return {
          key: index,
          regional: get(item, 'region_name', '--'),
          district: get(item, 'district_name', '--'),
          professional: get(item, 'member_name', '--'),
          totalOfCustomers: get(item, 'customers_count', 0),
          status_name: item.status_name,
          statusColor: item.statuscolor,
          actions: item
        }
      })
      const newFormattedData = {
        items: formattedRows,
        configuration: formattedConfiguration
      }
      setFormattedData(newFormattedData)
    } catch (error) {
      console.tron.log('error', error)
    }
  }

  function renderHeader() {
    return (
      <div className="default-header-div">
        <div className="default-header-breadcrumb">
          <CustomBreadcrumb match={match} history={history} />
          <Button
            className="default-header-button"
            type="primary"
            style={{ visibility: 'hidden' }}
            onClick={() => history.push('/customerWallet/create')}
          >
            {getMessage('storeCustomerWallet')}
          </Button>
        </div>
      </div>
    )
  }

  function renderHeaderAg() {
    const leftContents = (
      <React.Fragment>
        <h2>
          <b>{getMessage('listRtv')}</b>
        </h2>
      </React.Fragment>
    )

    const rightContents = (
      <React.Fragment>
        <div style={{ display: 'flex' }}>
          <IconField iconPosition="left">
            <InputIcon className="pi pi-search"> </InputIcon>
            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Pesquisar" />
          </IconField>
          <Button
            style={{ marginLeft: '10px' }}
            type="button"
            className="p-button-success mr-2"
            icon="pi pi-file"
            rounded
            onClick={exportCSVData}
            data-pr-tooltip="CSV"
          />
          <Button
            type="button"
            className="p-button-success mr-2"
            icon="pi pi-file-excel"
            severity="success"
            rounded
            onClick={exportExcelData}
            data-pr-tooltip="XLS"
          />
        </div>
      </React.Fragment>
    )

    return <Toolbar start={leftContents} end={rightContents} />
  }

  const statusBodyTemplate = (rowData) => {
    const status = get(rowData, 'status_name', STATUS.OPEN)
    const statusColor = get(rowData, 'statusColor', '#D6DAE0')
    return (
      <div className="div-list-status-table">
        <div className="wallet-status" style={{ backgroundColor: statusColor, fontSize: 14 }}>
          {status}
        </div>
      </div>
    )
  }

  const editBodyTemplate = ({ actions }) => {
    return (
      <Link to={`/customerWallet/${actions['district_id']}?memberId=${actions.member_id}`}>
        <Button style={{ marginLeft: -10, backgroundColor: 'transparent', border: 'none' }}>
          <Icon type="edit" className="default-actionContent-icon" />
        </Button>
      </Link>
    )
  }

  const columns = [
    { header: getMessage('menuRegion'), field: 'regional', filterField: 'regional', responsive: true },
    { header: getMessage('menuDistrict'), field: 'district', filterField: 'district', responsive: true },
    { header: getMessage('professional'), field: 'professional', filterField: 'professional', responsive: true },
    {
      header: getMessage('totalOfCustomers'),
      field: 'totalOfCustomers',
      filterField: 'totalOfCustomers',
      responsive: true
    },
    {
      header: getMessage('approvalStatus'),
      field: 'status_name',
      filterField: 'status_name',
      body: statusBodyTemplate,
      responsive: true
    },
    { header: 'Editar', body: editBodyTemplate, width: '5rem', responsive: true }
  ]

  return (
    <>
      {renderHeader()}
      <div className="card listCustomerWallet">
        {renderHeaderAg()}
        <DataTable
          ref={gridRef}
          itemsList={formattedData.items}
          filters={filters}
          columns={columns}
          emptyMessage="emptyCustomer"
        />
      </div>
    </>
  )
}

export default ListCustomerWallets
